$.datepicker.regional['fr'] = {
    clearText: 'Effacer',
    clearStatus: '',
    closeText: 'Fermer',
    closeStatus: 'Fermer sans modifier',
    prevText: '<Préc',
    prevStatus: 'Voir le mois précédent',
    nextText: 'Suiv>',
    nextStatus: 'Voir le mois suivant',
    currentText: 'Courant',
    currentStatus: 'Voir le mois courant',
    monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin',
    'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun',
    'Jul','Aoû','Sep','Oct','Nov','Déc'],
    monthStatus: 'Voir un autre mois',
    yearStatus: 'Voir un autre année',
    weekHeader: 'Sm',
    weekStatus: '',
    dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
    dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
    dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
    dayStatus: 'Utiliser DD comme premier jour de la semaine',
    dateStatus: 'Choisir le DD, MM d',
    dateFormat: 'dd/mm/yy',
    firstDay: 0,
    initStatus: 'Choisir la date',
    isRTL: false,
};

/*******************************************************************************************************/
/* CUSTOM FUNCTIONS
/*******************************************************************************************************/
function triggerShad(shad, action) {
    shad = shad ? ('#shad_' + shad):'#shad' ;

    if (action && action == 'add') {
        $(shad).addClass('actif');
    } else if (action) {
        $(shad).removeClass('actif');
    } else {
        return false;
    }
}

//define addMessage function here to avoid console error
function addMessage() {

    var formMotPerso = $('#mot_personnalise');

    if ($("#has_perso_word").prop('checked') === true) {
        formMotPerso.slideDown("slow");
        $('input[name=add_mot_perso]').val('ok');
    } else {
        formMotPerso.slideUp("speed");
        $('input[name=add_mot_perso]').val('no');
    }

}

//LOADING CTA
$('#btn_cmd_valid, .w-submit-button, .loader_scroll').click(function() {
    function greet() {
        $('.form_submit').removeClass('loading');
    }
    setTimeout(greet, 1000);
});

function fadeHeaderElems(from, action) {
    // Only if header background is transparent == On page top
    if (!$('#site_head_wrap.sticky').length) {
        if (action == 'add') {
            if (from == "right") {
                $('.block_top_links.left, .main_menu_wrapper, .block_top_links.logo').addClass('goTransparent');
            } else if (from == "left") {
                $('.block_top_links.right, .main_menu_wrapper, .block_top_links.logo').addClass('goTransparent');
            }
        } else {
            $('.goTransparent').removeClass('goTransparent');
        }
    }
}

/**
 * Keeps the gift message and stores it in session storage.
 * This function is called after a delay of 300 milliseconds.
 *
 * Client request: function to allow the saving of the personalized message in session storage.
 */
function keepGiftMessage() {
    setTimeout(function(){
        if ($("#has_perso_word").prop('checked') === false) {
            $("#has_perso_word").prop('checked');
            $('input[name=add_mot_perso]').val('ok');
        }
        $('#mot_personnalise').slideDown("slow");

            /* keep gift message value in session storage */
            // Get the text area element
            let $textArea = $("#mot_personnalise_texte");

            // Check if data is already stored in local storage
            if (sessionStorage.getItem("textAreaData")) {
            // If data is stored, retrieve it and set it as the value of the text area
            $textArea.val(sessionStorage.getItem("textAreaData"));
            }

            // Listen for changes to the text area
            $textArea.on("input", function() {
            // Store the new data in local storage
            sessionStorage.setItem("textAreaData", $textArea.val());
            });
    }, 300);
}
// enables triggering of the function to save the personalized message when adding a product from the cart to the wishlist
$(window).on("wishToBasket_complete", function (data) {
    keepGiftMessage();
})

/*******************************************************************************************************/
/* HEADER STICKY SCROLL
/*******************************************************************************************************/

var header = document.getElementById("site_head_wrap");

function onWinScroll() {
    var scrollTop = $(document).scrollTop();

    if (header.classList.contains("sticky")) {

        if (scrollTop < 100) {
            header.classList.remove("sticky");
        }
    } else {
        if (scrollTop >= 100) {
            header.classList.add("sticky");
        }
    }
}

$(window).on("scroll", onWinScroll);
onWinScroll();

$(function() {
    /* keep gift message value in session storage */
    // Get the text area element
    let $textArea = $("#mot_personnalise_texte");

    // Check if data is already stored in local storage
    if (sessionStorage.getItem("textAreaData")) {
        // If data is stored, retrieve it and set it as the value of the text area
        $textArea.val(sessionStorage.getItem("textAreaData"));
    }

    // Listen for changes to the text area
    $textArea.on("input", function() {
        // Store the new data in local storage
        sessionStorage.setItem("textAreaData", $textArea.val());
    });

    if ($('.button').hasClass('find_retailer')) {
        $('#btn_add_cart').remove();
    }

    // /***** BURGER MENU *****/
    $('.burger_menu_container').click(function() {
        $('body').addClass('noscroll');
        $('.burger_menu').toggleClass('is_clicked');
        $('.bot_header_wrapper').toggleClass('is_open');
        $('#shad_menu').addClass('actif menuShad');
        $('#header_mention_id, .header').toggleClass('nav_burger_open');
        $('.burger_menu_close').addClass('visible');

        var leftMenuHeight = $('.main_menu_wrapper.main_menu').height();
        var menuBottomHeight = $('#bottomMenu').height();
        var newHeight = (leftMenuHeight - menuBottomHeight) - 10;
        $('#container_menu_items').height(newHeight);

        // Initialize OverlayScrollbars on an element
        if (!menuBurgerInstance) {
            menuBurgerInstance = OverlayScrollbars(document.querySelector(".container_menu_items"), {
                className: "os-theme-dark",
                scrollbars: {
                    autoHide: "leave",
                    autoHideDelay: 0
                },
                overflowBehavior: {
                    x: "hidden",  // Hide the x-axis scrollbar
                    y: "scroll"   // Optionally, show the y-axis scrollbar
                }
            });
        }
    });

    $('.burger_menu_close').click(function() {
        $('body').removeClass('noscroll');
        $('.burger_menu').toggleClass('is_clicked');
        $('.bot_header_wrapper').toggleClass('is_open');
        $('#shad_menu').removeClass('actif menuShad');
        $('#header_mention_id, .header').toggleClass('nav_burger_open');
        $(this).removeClass('visible');

        // Destroy the instance to remove the custom scrollbar
        if (menuBurgerInstance) {
            menuBurgerInstance.destroy();
            menuBurgerInstance = null; // Reset the instance after destruction
        }

        // Destroy the instance to remove the custom scrollbar
        if (menuBurgerFull) {
            menuBurgerFull.destroy();
            menuBurgerFull = null; // Reset the instance after destruction
        }
    });

    var menu_timeout = setTimeout(null);

    $(".menu_itm_hover").on("mouseenter", function(evt) {
        var submenu = $(".submenu_wrapper", this);
        evt.preventDefault();
        clearTimeout(menu_timeout);

        var linkToClick = $(this).find('.has_submenu');

        // If the resolution is greater than 1201, handle the hover effect on menu items
        if (window.matchMedia("(min-width: 1201px)").matches) {
            submenu.addClass('menu_visible');
        // Otherwise, we handle the navigation in the burger menu when clicking on the items
        } else {
            var retourToIndex = $(this).find('.retour_low_res');

            linkToClick.on('click', function() {
                $(this).closest('.main_menu_itm').addClass('next_menu');
                if ($(this).siblings('.submenu_wrapper').length) {
                    $('#bottomMenu').hide();
                }
            });
            retourToIndex.on('click', function() {
                $(this).closest('.main_menu_itm').removeClass('next_menu');
                $('#bottomMenu').show();
            });
        }
    });

    /*******************************************************************************************************/
    /* Preheader swiper init & Close preheader
    /*******************************************************************************************************/
    if ($('.promo_swiper').length) {
        $("body").addClass("bandeauDelivery");
        if ($('.promo_swiper .swiper-slide').length > 1) {
            var preheader_swiper = new Swiper('.promo_swiper', {
                autoplay: true,
                slidesPerView : 1,
                loop: true,
                speed: 2000
            });
        }
    }

    if ($(".cartAssocSwiper").length) {
        new Swiper(".cartAssocSwiper", {
            slidesPerView: 4,
            spaceBetween: 40,
            breakpoints: {
                700: {
                slidesPerView: 3,
                },
                1024: {
                slidesPerView: 4,
                },
            }
        });
    }

    // Close preheader
    var headerDelivery = $(".header_mention");
    $(".close_delais").on("click", function() {
        $("body").removeClass("bandeauDelivery");
        $("#site_head_wrap").removeClass("bandeau_on");
        headerDelivery.slideUp(500, function() {
            headerDelivery.remove();
        });
    });

    /*******************************************************************************************************/
    /* SWIPER HP
    /*******************************************************************************************************/

    // SWIPER COVER
    if ($('.coverHomeSwiper').length) {
        let hasMultipleSlides = $('.coverHomeSwiper > .swiper-wrapper > .swiper-slide').length > 1;
        
        var coverHomeSwiper = new Swiper('.coverHomeSwiper', {
            autoplay: hasMultipleSlides ? { 
                delay: 5000,
                disableOnInteraction: false  // Prevents autoplay from stopping after user interaction
            } : false,
            slidesPerView: 1,
            loop: hasMultipleSlides,
            speed: 5000,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            on: {
                init: lazyLoadSwiperImages,
                slideChange: lazyLoadSwiperImages
            }
        });

        // Store swiper instance on the DOM element for the button to access
        if (document.querySelector('.coverHomeSwiper')) {
            document.querySelector('.coverHomeSwiper').swiper = coverHomeSwiper;
        }
        window.coverHomeSwiper = coverHomeSwiper;
        
        if (hasMultipleSlides) {
            initPauseButton();
        }
    }
    
    // SHOW WRAP SEARCH
    $('#trigger_recherche').on("click keypress", function(e) {
        if (e.type === 'keypress' && e.keyCode !== 13) return;
        
        if ($('.wrap_search_field').hasClass('actif')) {
            $('#shad_menu').removeClass('actif search_active');
            $('.wrap_search_field.actif').removeClass("actif");
            $('.main_menu_itm').parent().removeClass("hover");
            $('#container_menu_items .container_menu_items').removeClass('moveDown');
        } else {
            $('.wrap_search_field').addClass("actif");
            $('#container_menu_items .container_menu_items').addClass('moveDown');
            $('#shad_menu').addClass('actif search_active');
        }
    });

    $('#shad_menu').on('click', function() {
        if ($('.wrap_search_field').hasClass('actif')) {
            $('#shad_menu').removeClass('actif search_active');
            $('.wrap_search_field.actif').removeClass("actif");
        }
    });

    /* LANG SWITCH*/
    $('.wrap_lang').on({
        mouseenter: function (e) {
            $(this).parent('.left').addClass('onRollover');
            $(this).find('.lang_switch').addClass('hovering');
            $('#shad_menu').addClass('actif');
            fadeHeaderElems('left', 'add');
            //check if layer search product is actif
            if ($('.wrap_search_field').hasClass('actif')) {
                e.stopPropagation();
                $('.wrap_search_field').removeClass('actif');
            }

        },
        mouseleave: function (e) {
            $(this).parent('.left').removeClass('onRollover');
            $(this).find('.lang_switch').removeClass('hovering');
            $('#shad_menu').removeClass('actif');
            fadeHeaderElems();
            if ($('.wrap_search_field').hasClass('actif')) {
                e.stopPropagation();
            }
        },
    });

    /* LAYER CUSTOMER SERVICE*/
    $('.customer_service').on({
        mouseenter: function (e) {
            $(this).parent('.left').addClass('onRollover');
            $(this).find('.top_item_cta').addClass('hovering');
            $('#shad_menu').addClass('actif');
            fadeHeaderElems('left', 'add');
            //check if layer search product is actif
            if ($('.wrap_search_field').hasClass('actif')) {
                e.stopPropagation();
                $('.wrap_search_field').removeClass('actif');
            }
        },
        mouseleave: function (e) {
            $(this).parent('.left').removeClass('onRollover');
            $(this).find('.top_item_cta').removeClass('hovering');
            $('#shad_menu').removeClass('actif');
            fadeHeaderElems();
            if ($('.wrap_search_field').hasClass('actif')) {
                e.stopPropagation();
            }
        },
    });

    /**
    * TOP WISHLIST ROLLOVER
    */
    var topWish = $("#wishlist_top");

    topWish.mouseover(function(e) {
         //check if layer search product is actif
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
            $('.wrap_search_field').removeClass('actif');
        }
        $('#shad_menu').addClass('actif');
    }).mouseout(function() {
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
        } else {
            $('#shad_menu').removeClass('actif');
        }
    });

    /**
    * TOP MyAccountIsLogged ROLLOVER
    */
    var topMyAccountIsLogged = $(".block_top_item.my_account");

    topMyAccountIsLogged.mouseover(function(e) {
        //check if layer search product is actif
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
            $('.wrap_search_field').removeClass('actif');
        }
    }).mouseout(function() {
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
        }
    });

    /**
    * TOP CART ROLLOVER
    */
    var topCart = $("#cart_top");

    topCart.mouseover(function(e) {
        //check if layer search product is actif
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
            $('.wrap_search_field').removeClass('actif');
        }
    }).mouseout(function() {
        if ($('.wrap_search_field').hasClass('actif')) {
            e.stopPropagation();
        }
    });

    // NAV ENTREE RESOLUTION > 1200 px
    if ($(window).width() > 1200) {
        var hoverTimer;

        $('.main_menu_itm').on({
            mouseenter: function(e) {
                var searchField = $('.wrap_search_field');

                if (searchField.hasClass('actif')) {
                    hoverTimer = setTimeout(function() {
                        searchField.css('transition', 'none');
                        searchField.removeClass('actif');
                    }, 750);
                }

                $(this).parent().addClass('hover');

                if ($(this).find('.submenu_wrapper').length) {
                    triggerShad('menu', 'add');
                }
            },
            mouseleave: function(e) {
                clearTimeout(hoverTimer);
                $(this).parent().removeClass('hover');

                if ($(this).find('.submenu_wrapper').length) {
                    triggerShad('menu', 'remove');
                }

                $('.wrap_search_field').css('transition', 'transform, opacity .2s ease-in-out');
            }
        });
    }

    // ROLLOVER SCROLLBARS
    if ($('#cart_list').length) {
        if ($('#cart_list .product-link').length > 2) {
            $("#cart_list").overlayScrollbars({});
        }
    }

    if ($('#show_top_cart').length) {
        $('#show_top_cart .holder_scrollable').overlayScrollbars({});
    }

    if ($('.ss_menu_categ_wrapper').length) {
        $('.ss_menu_categ_wrapper .ss_cat_wrapper').each(function() {
            $(this).overlayScrollbars({
                overflowBehavior : {
                    x : "scroll",
                    y : "hidden"
                },
            });
        });
    }

    // smallscreens scrollbars
    if ($('#wishlist_not_logged').length) {
        $('#wishlist_not_logged').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    }

    if ($('#show_top_wish #cart_list').length) {
        $('#show_top_wish #cart_list').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    }

    // FAQ
    $('.theme').on('click', function() {
        $('.back_opacity').removeClass("actif");
        $(this).children('.faq_background_image').children().addClass("actif");
    })

    /*******************************************************************************************************/
    /* RAYON
    /*******************************************************************************************************/
    // check ProductInWishlist
    if ($('.imgWrapper').length > 0) {
        $(document).on("mouseenter", '.imgWrapper', function () {
            var produit_id = $(this).find("form input[name='produit_id']").val();
            if (produit_id > 0) {
                checkProductInWishlist(produit_id);
            }
        });
    }

    /* Hide Border Color last wrap Rayon & Search */
    if ($('.category .filters_container.bottom').length) {
        $('.filters_container.bottom').find('.form_submit').prev().children().css('border','0')
    }

    // FILTERS RAYON
    if ($('#rayon_sticky_block').length) {
        if ($('.wrapper_scrollable').length) {
            $('.wrapper_scrollable').overlayScrollbars({
                scrollbars: {
                    autoHide: "leave",
                    autoHideDelay: 0,
                }
            });
        }
    }

    //STATE MOUSEENTER MOUSELEAVE CLICK
    $(".category .customChecker, .category .form_itm.check").each(function() {
        $(this).mouseenter(function () {
            $(this).addClass('is_checked');
        });
        $(this).mouseleave(function () {
            $(this).removeClass('is_checked');
        });
        var input = $(this).find('input');
        var label = $(this).find('label');
        input.click(function () {
            if ($(this).next().hasClass('is_checked')) {
                $(this).next().removeClass('is_checked');
            } else {
                $(this).next().addClass('is_checked');
            }
        });
        label.click(function () {
            if ($(this).prev().hasClass('is_checked')) {
                $(this).prev().removeClass('is_checked');
            } else {
                $(this).prev().addClass('is_checked');
            }
        });
    });

    /* ALERTE STOCK STOP KEYPRESS ENTER*/
    $("input[name='mail_alerte_stock']").each(function() {
        $(this).keypress(function (e) {
            if (e.keyCode  == '13') {
                e.preventDefault();
            }
        });
    });

    /* AJAX PAGE RECHERCHE COUNT */
    if ($('body.category').length && $('body.category').hasClass('search_in')) {
        $(document).ajaxComplete(function() {
            // compteur attributs
            $('.wrapper_filtre input').each(function() {
                $(this).click(function() {
                    countItemFilter(this,this.attr('name'));
                })
            });
        });
    }

    /* STORE LOCATOR  */
    if ($('.satellite_store_details').length) {
         // Get current day
        const d = new Date();
        let day = d.getDay();
        if (day === 0) {
            day = 7; // hightlight dimanche
        }
        // hightlight current day
        $('.time_table li:nth-child('+ day +')').addClass('current');
    }

    /* FIX LOADING PAGE CONNEXION  */
    if ($('.login_wrapper').length) {
        $('.wrapper_bandeau_connexion img').addClass('fade_in');
        setTimeout(function() {
            $('.login_wrapper').addClass('fade_in');
        }, 100);
    }

    /*******************************************************************************************************/
    /* FICHE PRODUIT & RAYON
    /*******************************************************************************************************/

    /**
     * Clone price in express buy BTN (Gondole + Ray + Assoc)
     */
    if ($('.wrapperProdVertical').length) {

        $('.wrapperProdVertical').each(function () {
            var productPrice = $(this).find('.item_price');
            var productButton = $(this).find('.w-submit-button');
            var is_precommande = $(this).find('.w-submit-button').attr('data-is-preco');
            var text_precommande = $(this).find('.w-submit-button span');

            productPrice.insertAfter($(this).find('.item_subtitle'));

            if (is_precommande !== undefined ) {
                text_precommande.text(Translator.translate('add_basket_preco'));
            } else {
                productButton.find('.item_price').remove();
                productPrice.clone().appendTo(productButton);
            }
        });
    }

    // Page cadeau d'entreprise
    if ($('.cadeau_entreprise').length) {
        // Affichage de la lightbox des contacts
        if ($( '#lightbox_nos_contacts').length && $( '.cta_nos_contacts' ).length) {
            $(window).on( "scroll", function () {
                var headerH = $('#site_head_wrap').height();
                if ( $( '#site_head_wrap' ).hasClass( 'sticky' )) {
                    $( '.cta_nos_contacts' ).css( 'top', (headerH )  + 'px');
                } else {
                    $( '.cta_nos_contacts' ).css( 'top', '-100%');
                }
            });
        }
    }

    /**
     * Switch delivery infos on payment page
     */
    if ($('body.checkout').length) {
        $('.wrapper_payment').insertBefore('#cart_total');
    }

   // positionnement upselling
    if ($('.upselling.price').attr( "data-upselling")===0) {
        $('.upselling.price').hide;
    }

    handleDispatchPopup();

    // Swiper page ADV cover

    $(".cms-module.cover-module .coverSwiper").each(function() {
        var thisPagination = $(this).parent().find('.swiper-pagination');

        var adv_cover_swiper = new Swiper($(this), {
            paginationClickable: true,
            pagination: thisPagination,
            spaceBetween: 20,
            slidesPerView: "auto",
            freeMode: true,
            on: {
                init: lazyLoadSwiperImages,
                slideChange: lazyLoadSwiperImages
            }
        });
    });

    $(".cms-module.cover-module .coverSwiper").each(function() {
        var thisNext = $(this).parent().find('.swiper-cover-button-next')[0];
        var thisPrev = $(this).parent().find('.swiper-cover-button-prev')[0];

        var adv_cover_swiper = new Swiper(this, {
            watchOverflow: true,
            spaceBetween: 20,
            slidesPerView: 2,
            navigation: {
                nextEl: thisNext,
                prevEl: thisPrev,
            },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
            on: {
                init: function (swiper) {
                    var slidesVisible = Math.ceil(swiper.params.slidesPerView);
                    var indicesToLoad = [];
                    for (var i = swiper.activeIndex - 1; i <= swiper.activeIndex + slidesVisible; i++) {
                        indicesToLoad.push(i);
                    }
                    indicesToLoad.forEach(function (index) {
                        var slide = swiper.slides[index];
                        if (slide) {
                            $(slide).find('img[data-src]').each(function () {
                                var $img = $(this);
                                $img.attr('src', $img.attr('data-src')).removeAttr('data-src');
                            });
                        }
                    });
                },
                slideChange: function (swiper) {
                    var slidesVisible = Math.ceil(swiper.params.slidesPerView);
                    var indicesToLoad = [];
                    for (var i = swiper.activeIndex - 1; i <= swiper.activeIndex + slidesVisible; i++) {
                        indicesToLoad.push(i);
                    }
                    indicesToLoad.forEach(function (index) {
                        var slide = swiper.slides[index];
                        if (slide) {
                            $(slide).find('img[data-src]').each(function () {
                                var $img = $(this);
                                $img.attr('src', $img.attr('data-src')).removeAttr('data-src');
                            });
                        }
                    });
                }
            }
        })
    });

    /* MODULE GONDOLE INTEREST ACHAT EXPRESS ADD BASKET */
    gondoleInterest();

    if ($('.sameBillAddress').length > 0) {
        if ($('.w-newuser-form legend').first().text() == Translator.translate('votre_adresse_facturation')) {
            $('.sameBillAddress').hide();
        }
    }

    $('.modlink.modify').on('click', function (e) {
        let $targetEvent = $('.show_modif_info');
        let bloc_liv_hidden = $('.hidden_elem_liv', $targetEvent.closest('.bloc_livraison'));

        if (typeof bloc_liv_hidden != 'undefined' && bloc_liv_hidden != null && bloc_liv_hidden.length > 0) { // SW-11040 Case when bloc livraison does not show for some postal codes
            e.preventDefault();
            let bloc_liv = $targetEvent.closest('.bloc_livraison');
            if (bloc_liv_hidden.is(':visible')) {
                bloc_liv_hidden.slideUp();
            } else {
                if (!bloc_liv.is('.disabled')) {

                    bloc_liv_hidden.slideDown('.hidden_elem_liv', '', function () {

                        let $changeAdr = $('.select_change_adr', bloc_liv);

                        $changeAdr.attr('id', $('.active .choix_delivery').data('id-transporteur'));
                    });
                }
            }
        }
    });
    if ($('.bloc_livraison').length > 0) {
        $('.bloc_livraison').each(function () {
            $(this).on('click', function () {
                if(!$(this).hasClass('active')) {
                    $(this).find('.choix_delivery').chooseTransporteur();
                }
            });
        });
    }

    setTimeout(function() {
        $('.w-address-form').css('opacity', 1);
    }, 500);

    // Get width to add or remove class for different style on header for desktop and less than 1021px
    updateHeaderClassAndJs();
    menuBurgerSubMenuOverlayScroll();
    accordionMenu();
    //resetAccordionMenu()

    $(window).on('resize', function() {
        updateHeaderClassAndJs();
        menuBurgerSubMenuOverlayScroll();

        if ($(window).width() > 1200) {
            resetAccordionMenu();
        }
    });

    initSwiperCatalogue();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSwiperCatalogue, 200);
    });

    var swiperLogos = new Swiper('.bloc_logo', {
        slidesPerView: 5.6,
        spaceBetween: 110,
        navigation: {
            nextEl: '.bloc_logo_wrapper .swiper-button-next',
            prevEl: '.bloc_logo_wrapper .swiper-button-prev',
        },
        breakpoints: {
            1024: {
                spaceBetween: 10,
            },
            1120: {
                spaceBetween: 50,
            },
            1350: {
                spaceBetween: 80,
            },
            1620: {
                spaceBetween: 110,
            }
        }
    });
});

// Wait for the swiper to be initialized and available
function initPauseButton() {
    // Find the swiper container
    const homeSwiperContainer = $('.coverHomeSwiper');
    if (!homeSwiperContainer.length) return;
    
    // Get existing swiper instance (assumed to be stored globally or accessible)
    // Try to retrieve from Swiper's data attribute or window
    let swiper = homeSwiperContainer[0].swiper;
    if (!swiper && typeof window !== 'undefined' && window.preheader_swiper) {
        swiper = window.preheader_swiper;
    }

    if (!swiper) {
        // If swiper not found, retry after short delay
        setTimeout(initPauseButton, 200);
        return;
    }
    
    const autoplayPauseBtn = $('#autoplayPauseBtn');
    if (!autoplayPauseBtn.length) return;

    autoplayPauseBtn.css('display', 'flex');
    
    // Function to update button state based on autoplay status
    function updateButtonState() {
        if (swiper.autoplay && swiper.autoplay.running) {
            autoplayPauseBtn.html(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" fill="currentColor"/></svg>`);
        } else {
            autoplayPauseBtn.html(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>`);
        }
    }
    
    // Pause autoplay on click
    autoplayPauseBtn.on('click', function(e) {
        
        e.stopPropagation();
        if (swiper.autoplay && typeof swiper.autoplay.start === 'function' &&
            typeof swiper.autoplay.stop === 'function') {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
            } else {
                swiper.autoplay.start();
            }
            updateButtonState();
        }
    });
    
    // Listen to swiper autoplay events to keep button in sync
    if (typeof swiper.on === 'function') {
        swiper.on('autoplayStart', updateButtonState);
        swiper.on('autoplayStop', updateButtonState);
    }
    
    // Initial state
    updateButtonState();
}

function initSwiperCatalogue() {
    const swiperEl = document.querySelector('.swiper_catalogue');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    if (swiperEl.swiperInstance) {
        swiperEl.swiperInstance.destroy(true, true);
        swiperEl.swiperInstance = null;
    }

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    wrapper.style.display = 'none';
    void wrapper.offsetHeight;
    wrapper.style.display = '';

    const swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 3,
        loop: true,
        spaceBetween: 178,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper_catalogue .swiper-button-next',
            prevEl: '.swiper_catalogue .swiper-button-prev',
        },
        breakpoints: {
            700: {
                spaceBetween: 40,
            },
            1260: {
                spaceBetween: 60,
            },
            1360: {
                spaceBetween: 80,
            },
            1410: {
                spaceBetween: 110,
            },
            1540: {
                spaceBetween: 178,
            },
        }
    });

    swiperEl.swiperInstance = swiperInstance;
}

function accordionMenu() {
    // Accordion for menu 1201 boutique
    const countryTitle = $('#menu_boutiques .ss_cat_item:not(.continent_europe) .continent_title');
    const countryLists = $('#menu_boutiques .ss_cat_item:not(.continent_europe) ul.country_list');

    if ($('.bot_header_wrapper').hasClass('lessThan1201')) {
        countryLists.hide();
    }

    countryTitle.click(function () {
        if ($('.bot_header_wrapper').hasClass('lessThan1201')) {
            const countryList = $(this).next('ul.country_list');
            const isVisible = countryList.is(':visible');

            countryTitle.removeClass('active');
            countryLists.slideUp();

            if (!isVisible) {
                $(this).addClass('active');
                countryList.slideDown();
            }

            setTimeout(function() {
                menuBurgerInstance.update();
                menuBurgerFull.update();
            }, 150);
        }
    });
}

function resetAccordionMenu() {
    const countryTitle = $('#menu_boutiques .ss_cat_item:not(.continent_europe) .continent_title');
    const countryLists = $('#menu_boutiques .ss_cat_item:not(.continent_europe) ul.country_list');

    countryTitle.removeClass('active');
    $(countryLists).removeAttr('style');
}

// Get width to add or remove class for different style on header for desktop and less than 1021px
// Declare the variable outside the function
var menuBurgerInstance;
var menuBurgerFull;
function updateHeaderClassAndJs() {
    if ($(window).outerWidth() < 1201) {
        $('header .bot_header_wrapper').removeClass('greaterThan1201');
        $('header .bot_header_wrapper').addClass('lessThan1201');

        var leftMenuHeight = $('.main_menu_wrapper.main_menu').height();
        var menuBottomHeight = $('#bottomMenu').height();
        var newHeight = (leftMenuHeight - menuBottomHeight) - 10;
        $('#container_menu_items').height(newHeight);

        setTimeout(function() {
            // Initialize OverlayScrollbars on an element
            if (!menuBurgerInstance) {
                menuBurgerInstance = OverlayScrollbars(document.querySelector(".container_menu_items"), {
                    className: "os-theme-dark menuBurgerInstance",
                    scrollbars: {
                        autoHide: "leave",
                        autoHideDelay: 0
                    },
                    overflowBehavior: {
                        x: "hidden",  // Hide the x-axis scrollbar
                        y: "scroll"   // Optionally, show the y-axis scrollbar
                    }
                });
            }
        }, 100);

    } else {
        $('header .bot_header_wrapper').addClass('greaterThan1201');
        $('header .bot_header_wrapper').removeClass('lessThan1201');
        $('#container_menu_items').height('initial');

        setTimeout(function() {
            // Destroy OverlayScrollbars on an element
            if (menuBurgerInstance) {
                menuBurgerInstance.destroy();
                menuBurgerInstance = null; // Reset the instance after destruction
            }

            if (menuBurgerFull) {
                menuBurgerFull.destroy();
                menuBurgerFull = null; // Reset the instance after destruction
            }
        }, 100);
    }
}

var menuBurgerSubMenuInstances = []; // Declare the variable as an array
function menuBurgerSubMenuOverlayScroll() {
    if ($(window).outerWidth() < 1201) {
        setTimeout(function() {
            // Initialize OverlayScrollbars on an element
            if (menuBurgerSubMenuInstances.length === 0) {  // Check if instances are not initialized
                document.querySelectorAll(".ss_menu_categ_wrapper").forEach(function(element) {
                    const instance = OverlayScrollbars(element, {
                        className: "os-theme-dark menuBurgerSubMenuOverlayScroll",
                        overflowBehavior: {
                            x: "hidden",  // Hide the x-axis scrollbar
                            y: "scroll"   // Optionally, show the y-axis scrollbar
                        }
                    });

                    menuBurgerSubMenuInstances.push(instance);  // Store each instance in the array
                });
            }
        }, 100);

    } else {
        setTimeout(function() {
            // Destroy OverlayScrollbars on an element
            if (menuBurgerSubMenuInstances.length > 0) {
                menuBurgerSubMenuInstances.forEach(function(instance) {
                    instance.destroy(); // Destroy each instance
                });
                menuBurgerSubMenuInstances = []; // Reset the instances array after destruction
            }
        }, 100);
    }
}

//tunnel error date scroll to function custom event
window.addEventListener("errorDateDetected", function(event) {
    scrollToErrorDate();
});

function gondoleInterest() {
    /* MODULE GONDOLE INTEREST ACHAT EXPRESS ADD BASKET */
    if ($("#gondole_interest").length) {
        new Swiper("#gondole_interest", {
             direction: 'vertical',
             slidesPerView: 'auto',
            //  loop: true,
             mousewheel: true,
         });
    }
}

//tunnel error date scroll to function
function scrollToErrorDate() {
    if ($('.multidelivery_product_container').length) {
        var errorElement = $('.multidelivery_product_container .err_delivery_date:visible').first().parents('.multidelivery_product_container');
    } else {
        var errorElement = $('.err_delivery_date:visible').first().parents('.bloc_livraison');
    }
    var scrollAdjustment = errorElement.offset().top - 20;
    if (errorElement.length) {
        $('html, body').animate({
            scrollTop: scrollAdjustment
        }, 500);
    }
}

/**
 * Function called in _app when cart items are updated after an action (move to wishlist, change qte etc...)
 */
function updateCartElements() {
    $('.cart_product_line').each(function () {
        var formQteWrapper = $(this).find('.cart_product_sizecol.quantity');
        var formQte = $(this).find('form.qte_selector');
        formQteWrapper.append(formQte);
    });

    keepButtonGiftForProductOnly();

    // Check Warning msg display on Cart Page
    // Excluded product case
    var btn = $("#formPanier #btn_cmd_valid");
    if (document.querySelector('.cart_product_excluded') != null) {
        // Disable Cart Validation button
        btn.attr("disabled", "disabled");
    } else {
        btn.removeAttr("disabled");
        $("#panier_custom_message").hide();
    }

    keepGiftMessage();

    // Check if the cart still contains "multi delivery" products
    if ($('.multi_delivery_product') && $('.multi_delivery_product').length < 2) {
        $('.basket_warning.basket_multi_delivery').remove();
    }
}

if ($('.cart.step_1').length) {
    updateCartElements();
    upsellingPosition();
}

$('#formPanier').submit(function (evt) {
    let conveyorId = $('#conveyor_id').val();
    let currentDeliveryDate = ($('#delivery-date-' + conveyorId).length) ? $('#delivery-date-' + conveyorId).datepicker("getDate") : null;
    currentDeliveryDate = (currentDeliveryDate !== null) ? $.datepicker.formatDate("yy-mm-dd", currentDeliveryDate) : null;
    if (!currentDeliveryDate) {
        $('#order_delivery_date').val('');
    }

    // check delivery date
    if ($('#order_delivery_date').length) {
        let order_delivery_date = $('#order_delivery_date').val();

        if (!order_delivery_date) {
            let deliveryData = arrayDeliveryData[conveyorId] || {};
            let isPreco = deliveryData.isPreco || '';
            let firstDateFound = determinesFirstAvailableDeliveryDate(conveyorId, isPreco);
            let verifDate = firstDateFound ? verifyDateIntegrity(firstDateFound, conveyorId) : false;

            if (firstDateFound && (verifDate === true || (Array.isArray(verifDate) && verifDate.length === 1 && verifDate[0] === true))) {
                $('#order_delivery_date').val(firstDateFound.toISOString().split('T')[0]);
            } else {
                evt.preventDefault();
                $('.bloc_livraison.active .order_delivery_date').css('border', 'red 1px solid');
                $('.bloc_livraison.active .block-delivery-date .err_delivery_date').html(Translator.translate('err_delivery_date')).show();
                scrollToErrorDate()
                return false;
            }
        } else {
            let verifDate = verifyDateIntegrity(order_delivery_date, conveyorId);

            if (!verifDate) {
                evt.preventDefault();
                $('.bloc_livraison.active .order_delivery_date').css('border', 'red 1px solid');
                $('.bloc_livraison.active .block-delivery-date .err_delivery_date').html(Translator.translate('err_delivery_date')).show();
                scrollToErrorDate();
                return false;
            }
        }
    }

    var deliveryDate = $('#order_delivery_date').val();
    if (deliveryDate == '' || deliveryDate == '0000-00-00 00:00:00') {
        return false;
    }
});

$('.order_delivery_date').click(function() {
    $('.bloc_livraison.active .order_delivery_date').css('border', 'none');
    $('.bloc_livraison.active .block-delivery-date .err_delivery_date').empty().hide();
});

/**
 * Sets the position of upselling elements based on their visibility and data attribute.
 */
function upsellingPosition() {
    if ($('.upselling.price:visible')) {
        $('#cart_total').addClass('uspselling_visible');
    }

    if ($('.upselling.price').attr( "data-upselling")== 0) {
        $('.upselling.price').addClass('uspselling_hide');
        $('#cart_total').removeClass('uspselling_visible');
    }
}

// Gift Card
function toggleGiftCardBalance() {
    var connectBtn = $(".btn_container");

    if (connectBtn.hasClass("notLogged")) {
        location.href=path_relative_root+create_link('order_identification')+'?from=giftcard';
    } else {
        $(".pageGiftCard__main--infos").toggleClass('is-hidden');
        $(".headerTitles").toggleClass('is-hidden');
        $(".pageGiftCard__main--amountinfos").toggleClass('is-hidden');
        $(".showAmountBtn").toggleClass('is-hidden');
        $(".text-besoin-aide").toggleClass('is-hidden');
    }
};

$(document).ready(function() {
    $('.container__input-code .w-submit').on('click', function(){
        setTimeout(function() {
            if ($('#formGiftCard .w-input-note').hasClass('w-input-error')) {
                $('#formGiftCard .w-input-element').addClass('w-input-error');
            } else {
                $('#formGiftCard .w-input-element').removeClass('w-input-error');
            }
        }, 500);
    });

    $('#s_msgPerso').on('input', function() {
        var maxLength = 235;
        var currentLength = $(this).val().length;

        if (currentLength >= maxLength) {
            $(this).addClass('error-border');
        } else {
            $(this).removeClass('error-border');
        }
    });

    // Error and success messages
    $('#mes_err_contact').insertAfter('.accountCreate');
    $('#mes_err_contact').insertAfter('.w-has-tel');
    if ($('.wrapper_content_mes_infos').length && $('.wrapper_content_mes_infos .update_success').length) {
        $('.wrapper_content_mes_infos .update_success').css('opacity','0').insertBefore('.wrapper_content_mes_infos .w-form-line:last-child()').hide();

        setTimeout(function() {
            $('.wrapper_content_mes_infos .update_success').css('opacity','1').insertBefore('.wrapper_content_mes_infos .w-form-line:last-child()').show();
        }, 1000);
    }
});

function keepButtonGiftForProductOnly() {
    $('#cart_total .bill_line.giftCmd').hide();

    $('.basket_contents .product_line_basket').each( function () {
        let productId = $(this).attr('data-product-id');

        if (productId > 0) {
            $('#cart_total .bill_line.giftCmd').show();
        }
    });
}

function showLayer(type = 'lang', eventClose = null) {
    const $dropdown = $('#dropdown-content-' + type);

    if (eventClose === 'arrowClose') {
        $dropdown.removeClass('show');
    } else {
        $('.menuMobileDropdownContent').removeClass('show');
        $dropdown.addClass('show');
    }
}

function creerMarqueur(point, nom, adresse, ville, cp, pays, horaire, telephone, email, site, image, magasin_type, cpt, magasin_id, url, distance, currently_open, horaire_today) {
    // Pour ne le charger qu'une seul fois
    if (horaire_txt === null) horaire_txt = Translator.translate("horaires_map");

    const markerImage = document.createElement("img");
    markerImage.src = path_relative_root + "img/maps/marker.png";

    var marqueur = new google.maps.marker.AdvancedMarkerElement({
        position: point,
        content: markerImage,
    });

    marqueur.magasin_id = magasin_id;
    nom = $.trim(nom);
    adresse = $.trim(adresse);
    ville = $.trim(ville);
    cp = $.trim(cp);
    distance = $.trim(distance);
    pays = $.trim(pays);
    horaire = $.trim(horaire);
    telephone = $.trim(telephone);
    email = $.trim(email);
    site = $.trim(site);

    var ligneListe = '<div class="info_popup">';

    ligneListe += '<div class="name"><a onclick="createDataLayer(' + magasin_id + ')" href="' + url + '">' + nom + "</a></div>";

    ligneListe += '<div class="adresse">' + adresse + "<br />" + cp + ' <span class="city">' + ville + "</span> - " + pays + "</div>";

    ligneListe += '<div class="cta_row"><a href="https://maps.google.fr/maps?daddr=' + point.lat() + ',' + point.lng() + '">'
        + Translator.translate('go_to_store')
        + '</a><a onclick="createDataLayer(' + magasin_id + ')" href="' + url + '">'
        + Translator.translate('learn_more') + '</a></div>';

    ligneListe += "</div>";

    google.maps.event.addListener(marqueur, "click", function () {
        if (!infowindow) {
            infowindow = new google.maps.InfoWindow();
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        } else {
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        }
    });

    markersArray.push(marqueur);

    return marqueur;
}

function creerLigneListe(cpt, id, nom, adresse, ville, cp, pays, currently_open, horaire_today, distance, marqueur, picture_filtre, magasinId, stock, stockStatus, stock_quantity, client_id, favorite, beContacted, flag_available, url, shop_filter, telephone, query, lat, lng, horaire_plus) {
    // To only load it once
    if (horaire_txt === null) horaire_txt = Translator.translate("horaires_map");

    let current_page;
    if (document.body.classList.contains('customer')) {
        current_page = 'customer';
    } else if (document.body.classList.contains('store_locator')) {
        current_page = 'distributeur';
    } else if (document.body.classList.contains('product_page')) {
        current_page = 'product';
    }

    currently_open = parseFloat(currently_open);
    var div = document.createElement("li");

    div.className = "elem-list-distributeur";
    div.dataset.info = id;

    var info_horaire_today = !horaire_today ? "" : horaire_today;
    if (info_horaire_today.includes("%s")) {
        info_horaire_today = info_horaire_today.replace("%s", "");
    }
    var class_horaire_today = currently_open ? "store_open" : "store_close";
    var opening_hours = currently_open ? "green_open" : "red_close";
    var label_store_open = currently_open ? Translator.translate('open') : "";

    var magImg = '';
    if (picture_filtre != '') {
        magImg = '<div class="storePic"><a onclick="createDataLayer(' + id + ')" href="' + path_relative_root + url + '"><img src="' + picture_filtre + '" alt="' + nom + '" /></a></div>';
    }

    var picto_filter = shop_filter != '' ? 'has_filter' : '';

    // We choose the store url to a url otherwise store detail URL
    var ligneListe = '<div class="elem_list_contents">'
        + magImg
        + '<div class="storeInfos infos_block">'
        + '<h2 class="name"><a href="javascript:;" onclick="geolocGoto(' + lat + ', ' + lng + ')">' + nom + ' - <span class="ville">' + ville +'</span></a></h2>'
        + '<div class="store_info_wrapper">'
        + '<div class="upper_store_info_wrapper">'
        + '<div class="address"><a href="javascript:;" onclick="geolocGoto(' + lat + ', ' + lng + ')">' + adresse + " - " + cp + " " + ville + '</a></div>';
    
    if (telephone != '') {
        ligneListe += '<div class="phone_store">' + telephone + '</div>';
    }

    ligneListe += '<span class="horaire_today ' + opening_hours + '"><span class="marker_storeloc ' + class_horaire_today + '"></span><span class="' + (currently_open ? 'txt_store_open' : 'txt_store_close') + '">' + (currently_open ? label_store_open : Translator.translate('closed')) + '</span>';

    if (currently_open) {
        ligneListe += '<span class="txt">' + info_horaire_today.toLowerCase() + '</span>';
    }

    ligneListe += '</span>';
    ligneListe += '</div>';
    ligneListe += '<div class="store_more" data-store="' + id + '"><a href="' + path_relative_root + url + '">' + Translator.translate('know_more') + '</a></div>';
    ligneListe += '</div>';

    if (current_page == 'product') {
        let stock_status_msg = '';
        let stock_status_class = '';
        if (stock_quantity > 5) {
            stock_status_msg = Translator.translate('store_locator_product_available');
            stock_status_class = 'stock_available';
        } else if (stock_quantity > 0) {
            stock_status_msg = Translator.translate('store_locator_product_limited');
            stock_status_class = 'stock_limited';
        } else {
            stock_status_msg = Translator.translate('store_locator_product_unavailable');
            stock_status_class = 'stock_unavailable';
        }
        ligneListe += '<div class="stock_available">'
            + '<span class="stock_status ' + stock_status_class + '"></span>'
            + '<span class="stock_status_txt">' + stock_status_msg + '</span>'
        + '</div>';

        if (click_and_go == '1' || click_and_go == 1) {
            ligneListe += '<span class="store_delivery">' + Translator.translate('store_delivery_available') + '</span>';
        }
    }

    ligneListe += '</div>';

    // button addition
    if (current_page == 'product' || current_page == 'customer') {
        // button label
        let buttonText = (favorite == '1') ? Translator.translate('delete_as_favorite_store') : Translator.translate('choisir_ce_magasin');

        // button html
        ligneListe += '<span id="is_favorite_' + id + '" data-is-favorite="' + favorite + '"></span>'
            + '<button id="add_favorite_' + id + '" class="button secondary favorite_store_button" onclick="addToMyFavorites(' + id + ',' + client_id + ');">' + buttonText + '</button>';
    }

    // Closes .elem_list_contents, opened at the top of the template
    ligneListe += '</div>';

    div.innerHTML = ligneListe;

    $('.store_more').unbind('click').click(function () {
        var id = event.currentTarget.getAttribute('data-store') ? event.currentTarget.getAttribute('data-store') : '';
        if (id != '') {
            createDataLayer(id)
        }
    });

    return div;
}